<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<div class="k-overlay" *ngIf="addAddresOpen"></div>
<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;">Enquiry Recipients</h3>
      </div>

      <kendo-grid [data]="gridData" [loading]="dataService.loading" [resizable]="true"
      style="max-height: 450px;" [pageable]="true" [pageSize]="pageSize">

        <ng-template kendoGridToolbarTemplate position="top">
          <button (click)="onNew()" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> New
          </button>
        </ng-template>

        <kendo-grid-column title="Delete" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Address" field="address">
        </kendo-grid-column>

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

      <div class="d-grid d-md-flex justify-content-md-end">
        <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Close</button>
      </div>

    </div>
  </div>

</div>

<kendo-dialog *ngIf="confirmDeleteItem" title="Please confirm" (close)="onConfirmedClose('cancel')" [minWidth]="250"
  [width]="450">

  <h4>Delete Email - <b>{{currentItem?.address}}</b>?</h4>

  <kendo-dialog-actions>
    <button kendoButton (click)="onConfirmedClose('delete')" themeColor="primary">Delete</button>
    <button kendoButton (click)="onConfirmedClose('cancel')">
      Cancel
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="errorMsgOpen" (close)="onErrorDialogClose()">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em;">
      <span class="k-icon k-font-icon k-i-exclamation-circle"></span> Update Issue
    </div>
  </kendo-dialog-titlebar>

  <h5>The current address: {{this.currentItem?.address}} had a problem being removed.</h5>

  <kendo-dialog-actions>
    <button kendoButton (click)="onErrorDialogClose()" themeColor="primary">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-window *ngIf="addAddresOpen" (close)="close($event)"[width]="800"
[(top)]="windowTop" [(left)]="windowLeft">
  <kendo-window-titlebar>
    <span class="k-window-title">Add a New Enquiry Recipient Email Address</span>
  </kendo-window-titlebar>
  <casi-enquiry-recipient (onSave)="onAddressSave($event)" (onCancel)="closeAddress()"></casi-enquiry-recipient>
</kendo-window>
